import {
  faqAnswerStyle,
  faqContainerStyle,
  faqDividerStyle,
  faqHeadlineStyles,
  faqQuestionStyle,
} from "~/landing-pages/components/FAQ/shared-faq-styles";
import { LandingPageFAQ } from "~/landing-pages/landing-page-types";
import { Body, Headline } from "~/ui-library";

export type FAQSideBySideProps = {
  appearance: "brand" | "dark" | "light";
  faqs: LandingPageFAQ[];
  title?: string;
};

export const FAQSideBySide: React.FC<FAQSideBySideProps> = ({
  appearance,
  faqs,
  title = "Frequently asked questions",
}) => (
  <div className={faqContainerStyle({ appearance })}>
    <div
      className={faqDividerStyle({
        appearance,
        className: "mx-auto max-w-7xl px-6 py-4 sm:py-6 lg:px-8 lg:py-8",
      })}
    >
      <Headline
        as="h3"
        level={3}
        mdLevel={2}
        className={faqHeadlineStyles({ appearance })}
      >
        {title}
      </Headline>
      <dl
        className={faqDividerStyle({
          appearance,
          className: "mt-10 space-y-8",
        })}
      >
        {faqs.map((faq, index) => (
          <div key={index} className="pt-8 lg:grid lg:grid-cols-12 lg:gap-8">
            <Body
              as="dt"
              bold
              className={faqQuestionStyle({
                appearance,
                className: "lg:col-span-5",
              })}
            >
              {faq.question}
            </Body>
            <dd className="mt-4 lg:col-span-7 lg:mt-0">
              <Body as="p" className={faqAnswerStyle({ appearance })}>
                {faq.answer}
              </Body>
            </dd>
          </div>
        ))}
      </dl>
    </div>
  </div>
);
